function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.8 7.84H1.2C0.0959999 7.84 0 8.71612 0 9.8C0 10.8839 0.0959999 11.76 1.2 11.76H26.8C27.904 11.76 28 10.8839 28 9.8C28 8.71612 27.904 7.84 26.8 7.84ZM26.8 15.68H1.2C0.0959999 15.68 0 16.5561 0 17.64C0 18.7239 0.0959999 19.6 1.2 19.6H26.8C27.904 19.6 28 18.7239 28 17.64C28 16.5561 27.904 15.68 26.8 15.68ZM1.2 3.92H26.8C27.904 3.92 28 3.04388 28 1.96C28 0.87612 27.904 0 26.8 0H1.2C0.0959999 0 0 0.87612 0 1.96C0 3.04388 0.0959999 3.92 1.2 3.92Z",
  fill: "#404047"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.c164793f.svg";
export { ForwardRef as ReactComponent };